// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"16":"9522d50c","25":"68bc691c","340":"1dc85561","595":"2c804ff2"}[chunkId] + ".chunk.css";
};